/** @format */
import Master from '../Layouts/Master';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../Shared/hooks/api/Index';
import { error, success } from '../../Shared/Components/Toast';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import { useEffect } from 'react';
import { useContext } from 'react';
import { EventContext } from '../../Contexts/EventContext';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import Loading from '../../Shared/Components/Loading';

const validationSchema = Yup.object().shape({
	roles_name: Yup.array()
		.required('انتخاب نقش الزامی است')
		.min(1, 'حداقل باید یک نقش انتخاب کنید'),
});

const UserRole = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const eventContext = useContext(EventContext);
	const [submitFormLoading, setSubmitFormLoading] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const getRoles = async () => {
			setLoading(true);
			await useApi.get(
				`user/${id}`,
				{},
				(res) => {
					eventContext.user = res.data.data;
				},
				(err) => {
					setLoading(false);
					error('هنگام دریافت اطلاعات خطایی رخ داده است');
				},
			);
			await useApi.get(
				'user/role',
				{},
				(res) => {
					eventContext.roles = res.data.data;
					setLoading(false);
				},
				(err) => {
					setLoading(false);
					error('هنگام دریافت اطلاعات خطایی رخ داده است');
				},
			);
		};
		getRoles();
	}, [id]);

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);
		values['roles_name'] = values.roles_name.map((r) => r.name);
		values['user_id'] = eventContext.user.id;
		await useApi.post(
			'/user/role/assign',
			values,
			(res) => {
				success('نقش با موفقیت به کاربر داده شد');
				navigate('/panel/user', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};
	return loading ? (
		<Loading />
	) : (
		<Master>
			<Formik
				initialValues={{
					roles_name: eventContext.user?.role ?? [],
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='d-flex flex-column border rounded p-2 mt-3'>
							<div className='w-100 form-group d-flex flex-row'>
								<div className='w-100 d-flex flex-column mt-1 mx-2'>
									<label className='text-dark-mode f-14 text-right'>نقش</label>
									<Select
										isMulti
										defaultValue={eventContext.user?.roles}
										closeMenuOnSelect={false}
										options={eventContext.roles}
										onChange={(value) =>
											setFieldValue('roles_name', value, true)
										}
										noOptionsMessage={() => 'لطفا نقش ها را انتخاب کنید'}
										getOptionLabel={(c) => c.description}
										getOptionValue={(c) => c.name}
										className='w-100'
										placeholder='انتخاب کنید...'
									/>
									<ErrorMessage classes='my-2' error={errors.roles_name} />
								</div>
							</div>
						</div>
						<div className='d-flex flex-row justify-content-end'>
							<button className='btn btn-info btn-sm f-14'>
								{submitFormLoading ? (
									<div
										className='spinner-border spinner-border-sm text-white mb-1'
										role='status'></div>
								) : (
									'ثبت نقش'
								)}
							</button>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default UserRole;
